import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie'; // Cookie kullanımını ekliyoruz

const api = "https://apideneme.com.tr/api/item";

const CreateItem = () => {
    console.log("CreateItem bileşeni render edildi");

    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [price, setPrice] = useState("");
    const [image, setImage] = useState(null); // Resim durumu
    const [error, setError] = useState(""); // Hata durumu
    const navigate = useNavigate();

    // Component yüklendiğinde cookie'yi kontrol et
    useEffect(() => {
        const userToken = Cookies.get('user_token');
        if (!userToken) {
            navigate('/'); // Token yoksa login sayfasına yönlendir
        }
    }, [navigate]);

    const post = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("name", name);
        formData.append("description", description);
        formData.append("price", price);
        if (image) {
            formData.append("image", image); // Resmi ekle
        }
        
        const userId = localStorage.getItem('user_id'); // Kullanıcı ID'sini al
        formData.append("user_id", userId); // Kullanıcı ID'sini formData'ya ekle

        try {
            await axios.post(api, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            
            // Başarılı kayıttan sonra yönlendirme işlemi
            if (userId === "1") {
                navigate("/items"); // Adminse /items sayfasına yönlendir
            } else {
                navigate("/user-items"); // Admin değilse /user-items sayfasına yönlendir
            }
        } catch (error) {
            console.error("Kaydetme sırasında hata oluştu:", error);
            setError(error.response?.data?.message || 'Kaydetme işlemi başarısız oldu.');
        }
    };

    const handleBack = () => {
        const userId = localStorage.getItem('user_id');
        if (userId === "1") {
            navigate("/items"); // Adminse items sayfasına yönlendir
        } else {
            navigate("/user-items"); // Diğer kullanıcılar için user-items sayfasına yönlendir
        }
    };

    return (
        <div>
            <button 
                className="btn btn-secondary position-absolute" 
                style={{ top: '10px', right: '10px' }} 
                onClick={handleBack}
            >
                BACK
            </button>
            <h3>Eleman Ekle</h3>
            <div className="container">
                <div className="row d-flex align-items-center justify-content-center">
                    <div className="col-md-6">
                        {error && <p className="text-danger">{error}</p>} {/* Hata mesajını göster */}
                        <form onSubmit={post}>
                            <div className="mb-3">
                                <label className="form-label">Name</label>
                                <input
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    type="text"
                                    className="form-control"
                                    required
                                    style={{
                                        backgroundColor: "#f0f8ff",
                                        border: "1px solid #ced4da",
                                        color: "#333",
                                    }}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Description</label>
                                <input
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    type="text"
                                    className="form-control"
                                    required
                                    style={{
                                        backgroundColor: "#f0f8ff",
                                        border: "1px solid #ced4da",
                                        color: "#333",
                                    }}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Price</label>
                                <input
                                    value={price}
                                    onChange={(e) => setPrice(e.target.value)}
                                    type="number"
                                    className="form-control"
                                    required
                                    style={{
                                        backgroundColor: "#f0f8ff",
                                        border: "1px solid #ced4da",
                                        color: "#333",
                                    }}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Image</label>
                                <input
                                    type="file"
                                    onChange={(e) => setImage(e.target.files[0])}
                                    className="form-control"
                                />
                            </div>

                            <button type="submit" className="btn btn-primary">
                                Kaydet
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateItem;
